'use strict';

module.exports = function (_ref) {
  var keychain = _ref.keychain;
  return function (name, password) {
    return keychain.exportKey(name, password);
  };
};